const formatNum = (amount) => Math.round((amount + Number.EPSILON) * 100) / 100;

export default formatNum;
